var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChangePass = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,6.7c0-1.3,0.2-2.5,0.8-3.2C6.9,2.7,8,2.2,10,2.2c2,0,3.1,0.5,3.7,1.3c0.6,0.8,0.8,1.9,0.8,3.2v1.2 c-0.1,0-0.2,0-0.3,0H5.8c-0.1,0-0.2,0-0.3,0V6.7z M4.5,7.9V6.7c0-1.4,0.2-2.8,1-3.8C6.4,1.8,7.8,1.2,10,1.2c2.2,0,3.6,0.6,4.5,1.7 c0.8,1,1,2.4,1,3.8v1.2c1,0.1,1.8,0.4,2.4,0.9c0.8,0.8,1,2,1,3.7v1.7c0,1.7-0.2,2.9-1,3.7c-0.8,0.8-2,1-3.7,1H5.8 c-1.7,0-2.9-0.2-3.7-1c-0.8-0.8-1-2-1-3.7v-1.7c0-1.7,0.2-2.9,1-3.7C2.7,8.3,3.5,8,4.5,7.9z M10,10.8c-0.7,0-1.3,0.3-1.8,0.8 c-0.5,0.5-0.8,1.1-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.1,0.8,1.8,0.8c0.7,0,1.3-0.3,1.8-0.8s0.8-1.1,0.8-1.8 c0-0.7-0.3-1.3-0.8-1.8C11.3,11,10.7,10.8,10,10.8z M8.9,12.2c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.8,0.2,1.1,0.5 c0.3,0.3,0.5,0.7,0.5,1.1s-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1 S8.6,12.5,8.9,12.2z M2.2,12.5c0-1.7,0.2-2.5,0.7-3c0.5-0.5,1.3-0.7,3-0.7h8.3c1.7,0,2.5,0.2,3,0.7c0.5,0.5,0.7,1.3,0.7,3v1.7 c0,1.7-0.2,2.5-0.7,3c-0.5,0.5-1.3,0.7-3,0.7H5.8c-1.7,0-2.5-0.2-3-0.7s-0.7-1.3-0.7-3V12.5z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChangePass, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/change-pass.b0fdeceb.svg";
export { ForwardRef as ReactComponent };